/**
 * src/components/ui/Button.tsx
 * =============================================================================
 * Botón base. Variante minimalista alineada con la estética Linear/Notion:
 * fondo plano, bordes sutiles, radios pequeños, sin sombras dramáticas.
 *
 * Las clases vienen de `buttonVariants.ts` para mantener este archivo
 * limpio de exports adicionales (Fast Refresh exige que un archivo de
 * componente no exporte constantes).
 *
 * Variantes: primary | secondary | outline | ghost | danger
 * Tamaños:   sm | md (default) | lg
 *
 * El botón NO debe contener lógica. Pasa `onClick` desde arriba.
 * =============================================================================
 */

import { forwardRef, type ButtonHTMLAttributes } from 'react'
import { type VariantProps } from 'class-variance-authority'
import { cn } from '@/lib/utils'
import { buttonVariants } from '@/components/ui/buttonVariants'

export interface ButtonProps
  extends ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof buttonVariants> {}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(function Button(
  { className, variant, size, ...props },
  ref,
) {
  return (
    <button ref={ref} className={cn(buttonVariants({ variant, size }), className)} {...props} />
  )
})
